// removed by extract-text-webpack-plugin
module.exports = {"email":"_3Lj7u"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SocialShare/EmailShare.scss
// module id = ./src/components/SocialShare/EmailShare.scss
// module chunks = 4